<template>
  <v-select
    class="sidebar-status-select"
    dense
    hide-details
    hide-selected
    :value="computedValue"
    :items="items"
    :menu-props="{ offsetY: true }"
    :style="{ 'background-color': backgroundColor }"
    :disabled="!isEditingOn"
    @input="$emit('input', $event)"
    :append-icon="isEditingOn ? '$dropdown' : ''"
  >
    <template #item="{ item }">
      <span
        class="sidebar-status-item"
        :style="{
          color: item.color || 'rgba(0,145,234)',
          'background-color': item.shadowColor || 'rgba(0,145,234,0.2)',
        }"
      >
        {{ item.value }}
      </span>
    </template>
    <template #selection="{ item }">
      <div class="sidebar-status-selection">
        {{ item.value }}
      </div>
    </template>
  </v-select>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
  name: 'SidebarStatusSelect',
  props: {
    value: {
      type: String,
    },
    isEditingOn: {
      type: Boolean,
      default: false,
    },
    initialEmpty: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      required: true,
    },
    colors: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    statuses: get('admin/modulesMapping@:type.statuses'),
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
    items() {
      const items = [];
      for (const statusKey of Object.keys(this.statuses)) {
        const status = { ...this.colors[statusKey], value: this.statuses[statusKey] };
        items.push(status);
      }
      return items;
    },
    backgroundColor() {
      const item = this.items.find(item => item.value === this.value);
      return item ? item.color || 'rgba(0,145,234)' : 'rgba(0,145,234)';
    },
  },
  beforeMount() {
    if (!this.initialEmpty && !this.computedValue) {
      this.computedValue = this.items[0].value;
    }
  },
};
</script>
<style lang="scss" scoped>
.sidebar-status-select {
  border-radius: 4px;
  padding: 0 8px;
  max-width: fit-content;
}
.sidebar-status-item {
  padding: 0 4px;
  border-radius: 4px;
}
.sidebar-status-selection {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  max-width: inherit;
  white-space: nowrap;
  color: white;
}
::v-deep .v-list-item {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 11px !important;
  line-height: 20px;
  min-height: 30px;
  padding: 0 8px;
}
::v-deep .v-input__slot::after {
  display: none;
}
::v-deep .v-input__slot::before {
  display: none;
}
::v-deep .v-input__icon .v-icon {
  color: white !important;
}
.v-select--is-menu-active {
  ::v-deep .v-icon {
    padding-bottom: 0px !important;
  }
}
</style>
